import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import moment from 'moment';
import {
    addSupportingDocuments,
    updateSupportingDocuments,
    getCustomer
} from 'school-space-client/api';
import { UserContext } from 'school-space-client/components';
import uploads from 'services/uploads';
import withNotifications from 'shared/context/notification/withNotifications';
import UploadSupportingForm from './uploadform';

const SafegurdingPolicy = ({
    documents,
    documentTypeConst,
    setGlobalDocuments,
    context: { showNotification }
}) => {
    const user = useContext(UserContext);
    const [progress, setProgress] = useState(0);
    const [document, setDocument] = useState('');
    const [isExempt, setIsExempted] = useState(false);
    const [exemptFlag, setExemptFlag] = useState(false);
    const [expiryDate, setExpiryDate] = useState('');
    const [tempDocument, setTempDocument] = useState([]);

    const uploadFiles = async file => {
        const { REACT_APP_S3_BUCKET_NAME: bucketName, REACT_APP_S3_REGION: region } = process.env;

        return uploads.uploadFileToS3(file, {
            bucketName,
            region
        });
    };

    const addDocument = async payload => {
        setProgress(50);
        await addSupportingDocuments(user.id, payload)
            .then(data => {
                setProgress(100);
                setDocument(data.name);
                const tempdocuments = {
                    ...documents,
                    safeGaurdingPolicy: {
                        ...data
                    }
                };
                setGlobalDocuments(tempdocuments);
                setProgress(0);
                showNotification('Document added successfully! 🚀');
                return window.location.reload(true);
            })
            .catch(error => {
                setProgress(0);
                return showNotification('Error adding document. ⛔️', error);
            });
    };

    const editDocument = async payload => {
        setProgress(50);
        await updateSupportingDocuments(user.id, documents.safeGaurdingPolicy.id, payload)
            .then(async data => {
                setProgress(100);
                setDocument(data.name);
                const tempdocuments = {
                    ...documents,
                    safeGaurdingPolicy: {
                        ...data
                    }
                };
                setGlobalDocuments(tempdocuments);
                setProgress(0);
                showNotification('Document added successfully! 🚀');
                return window.location.reload(true);
            })
            .catch(error => {
                setProgress(0);
                return showNotification('Error ⛔️', error);
            });
    };

    const refreshDataCustomer = () => {
        getCustomer(user.id)
            .then(data => {
                user.setCustomerDeposits(data.customerDeposits);
                user.setSupportingDocuments(data.supportingDocuments);
            })
            .catch(error => {
                return showNotification('Error. ⛔️', error);
            });
    };

    const safeGaurdingPolicy = async formData => {
        if (isExempt) {
            const payload = {
                customerId: user.id,
                approvalStatus: false,
                name: '',
                documentUrl: '',
                documentType: documentTypeConst.safeGaurdingPolicy,
                expiryDate: formData.expiryDate || moment().format('YYYY-MM-DD'),
                isExempt
            };
            setExemptFlag(isExempt);
            if (documents.safeGaurdingPolicy.customerId !== '') {
                await editDocument(payload);
            } else {
                await addDocument(payload);
            }
            return refreshDataCustomer();
        }
        setProgress(25);
        if ((formData.tempDocument[0] || []).length !== 0) {
            const resultS3 = await uploadFiles(formData.tempDocument[0]);
            if (resultS3.result.ok) {
                const payload = {
                    customerId: user.id,
                    approvalStatus: false,
                    name: resultS3.key,
                    documentUrl: resultS3.location,
                    documentType: documentTypeConst.safeGaurdingPolicy,
                    expiryDate: formData.expiryDate || moment().format('YYYY-MM-DD'),
                    isExempt
                };
                if (document.length !== 0) {
                    await editDocument(payload);
                    return refreshDataCustomer();
                }
                if (documents.safeGaurdingPolicy.customerId !== '') {
                    await editDocument(payload);
                } else {
                    await addDocument(payload);
                }
                return refreshDataCustomer();
            }
            setProgress(0);
            return showNotification('Error while uploading. ⛔️');
        }
        setProgress(0);
        return showNotification('No document selected. ⛔️');
    };

    useEffect(() => {
        setDocument(documents.safeGaurdingPolicy.name);
        setExpiryDate(documents.safeGaurdingPolicy.expiryDate);
        setIsExempted(documents.safeGaurdingPolicy.isExempt);
        setExemptFlag(documents.safeGaurdingPolicy.isExempt);
    }, [
        documents.safeGaurdingPolicy.name,
        documents.safeGaurdingPolicy.expiryDate,
        documents.safeGaurdingPolicy.isExempt
    ]);
    return (
        <>
            <Formik
                enableReinitialize
                initialValues={{
                    expiryDate,
                    isExempt,
                    exemptFlag,
                    setExpiryDate,
                    document,
                    setDocument,
                    tempDocument,
                    setIsExempted,
                    setTempDocument,
                    progress,
                    setProgress
                }}
                onSubmit={safeGaurdingPolicy}
                render={({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue
                }) => (
                    <UploadSupportingForm
                        showExpiryDate={false}
                        showExempt
                        exemptFlag={values.exemptFlag}
                        title="Safeguarding Policy"
                        expiryDate={values.expiryDate}
                        setExpiryDate={values.setExpiryDate}
                        document={values.document}
                        setDocument={values.setDocument}
                        tempDocument={values.tempDocument}
                        setTempDocument={values.setTempDocument}
                        progress={values.progress}
                        setProgress={values.setProgress}
                        isExempt={values.isExempt}
                        setIsExempted={values.setIsExempted}
                        errors={errors}
                        touched={touched}
                        submit={handleSubmit}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                    />
                )}
            />
        </>
    );
};

SafegurdingPolicy.defaultProps = {
    documents: {
        riskAssessment: {
            id: '',
            customerId: '',
            name: '',
            documentType: '',
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        },
        safeGaurdingPolicy: {
            id: '',
            customerId: '',
            name: '',
            documentType: '',
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        },
        liabilityInsurance: {
            id: '',
            customerId: '',
            name: '',
            documentType: '',
            approvalStatus: false,
            expiryDate: '',
            documentUrl: ''
        }
    },
    documentTypeConst: {
        safeGaurdingPolicy: 'safeGaurdingPolicy',
        riskAssessment: 'riskAssessment',
        liabilityInsurance: 'liabilityInsurance'
    }
};

SafegurdingPolicy.propTypes = {
    documents: PropTypes.shape({
        riskAssessment: PropTypes.shape({
            id: PropTypes.string,
            customerId: PropTypes.string,
            name: PropTypes.string,
            documentType: PropTypes.string,
            approvalStatus: PropTypes.bool,
            expiryDate: PropTypes.string,
            documentUrl: PropTypes.string
        }),
        safeGaurdingPolicy: PropTypes.shape({
            id: PropTypes.string,
            customerId: PropTypes.string,
            name: PropTypes.string,
            documentType: PropTypes.string,
            approvalStatus: PropTypes.bool,
            expiryDate: PropTypes.string,
            isExempt: PropTypes.bool,
            documentUrl: PropTypes.string
        }),
        liabilityInsurance: PropTypes.shape({
            id: PropTypes.string,
            customerId: PropTypes.string,
            name: PropTypes.string,
            documentType: PropTypes.string,
            approvalStatus: PropTypes.bool,
            expiryDate: PropTypes.string,
            documentUrl: PropTypes.string
        })
    }),
    documentTypeConst: PropTypes.shape({
        safeGaurdingPolicy: PropTypes.string,
        riskAssessment: PropTypes.string,
        liabilityInsurance: PropTypes.string
    }),
    setGlobalDocuments: PropTypes.func.isRequired,
    context: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withNotifications(SafegurdingPolicy);
